var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "menu"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 1.66663C15.4602 1.66663 15.8333 2.03972 15.8333 2.49996L15.8333 17.5C15.8333 17.9602 15.4602 18.3333 15 18.3333C14.5398 18.3333 14.1667 17.9602 14.1667 17.5L14.1667 2.49996C14.1667 2.03972 14.5398 1.66663 15 1.66663Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.99999 1.66663C10.4602 1.66663 10.8333 2.03972 10.8333 2.49996L10.8333 17.5C10.8333 17.9602 10.4602 18.3333 9.99999 18.3333C9.53976 18.3333 9.16666 17.9602 9.16666 17.5L9.16666 2.49996C9.16666 2.03972 9.53976 1.66663 9.99999 1.66663Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.83333 2.49996C5.83333 2.03972 5.46023 1.66663 4.99999 1.66663C4.53976 1.66663 4.16666 2.03972 4.16666 2.49996L4.16666 17.5C4.16666 17.9602 4.53975 18.3333 4.99999 18.3333C5.46023 18.3333 5.83333 17.9602 5.83333 17.5L5.83333 2.49996Z",
    fill: "currentColor"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.df6914c585c82238b85ab6cd5e09aaca.svg";
export { ForwardRef as ReactComponent };